import * as queries from '@queries/utils';

export const fetchDistributionBet = (id) =>
  queries.getQuery('/api/distribution-pronostic', 'idMatch=' + id, {});

export const fetchMostPredicted = (id) =>
  queries.getQuery('/api/most-predicted', 'idMatch=' + id, {});

export const fetchWinner = (id) => queries.getQuery('/api/winner', 'idMatch=' + id, {});
